if (!customElements.get('bag-tag-personalization')) {
  customElements.define(
    'bag-tag-personalization',
    class BagTagPersonalization extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.productFormId);
        this.productInfo = this.closest('product-info');
        this.emblemPanel = this.querySelector('[data-emblem-panel]');
        this.emblemInput = this.querySelector('[data-emblem-input]');
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.productInfo?.addEventListener('change', this.handleChange);
        this.form?.addEventListener('submit', this.handleSubmit, true);
        this.updateEmblemField();
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.handleChange);
        this.form?.removeEventListener('submit', this.handleSubmit, true);
      }

      handleChange(event) {
        if (event.target?.dataset?.optionName === this.dataset.emblemOption) {
          this.updateEmblemField();
        }
      }

      handleSubmit(event) {
        this.updateEmblemField();

        if (!this.form?.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
          this.form.querySelector(':invalid')?.focus();
        }
      }

      updateEmblemField() {
        const selectedOption = this.productInfo?.querySelector(
          `[data-option-name="${CSS.escape(this.dataset.emblemOption)}"]:checked`,
        );
        const hasEmblem = selectedOption?.value === this.dataset.emblemValue;

        if (!this.emblemPanel || !this.emblemInput) return;

        this.emblemPanel.hidden = !hasEmblem;
        this.emblemInput.disabled = !hasEmblem;
        this.emblemInput.required = hasEmblem;

        if (!hasEmblem) this.emblemInput.value = '';
      }
    },
  );
}
